// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"0b681231ca2ab873","6332":"9776c2bac2ca55c7","8552":"dcb0b14dc2883b9c"}[chunkId] + ".css";
};